import React, { useState } from 'react';

import { Container, Form, Button, Card, Alert, Spinner } from 'react-bootstrap';
import { API_CONFIG } from '../../config/api';

const LoginPage = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);


  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    const formData = new FormData();
    formData.append('username', username.trim());
    formData.append('password', password);

    try {
      const response = await fetch(API_CONFIG.LOGIN_URL, {
        method: 'POST',
        body: formData,
      });

      let data;
      const text = await response.text();
      try {
        data = JSON.parse(text);
      } catch (jsonErr) {
        data = { success: text.includes("Login successful"), message: text };
      }

      if (data.success || (data.message && data.message.toLowerCase().includes("login successful"))) {
        localStorage.setItem('isAdminLoggedIn', 'true');
        window.location.href = '/admin/dashboard';
      } else {
        throw new Error(data.message || 'Invalid username or password.');
      }
    } catch (err) {
      setError(err.message || 'Failed to login. Please verify server connection.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container className="d-flex align-items-center justify-content-center py-5" style={{ minHeight: '80vh' }}>
      <Card style={{ width: '26rem', borderRadius: '16px', border: '1px solid var(--border-medium, #444)', background: 'var(--bg-card, #1c1d22)', color: 'var(--text-primary, #fff)' }}>
        <Card.Body className="p-4">
          <h2 className="text-center mb-4 font-weight-bold">Admin Portal</h2>
          <p className="text-center text-muted mb-4" style={{ fontSize: '0.9rem' }}>
            Sign in to manage products & service centres.
          </p>

          {error && <Alert variant="danger" className="mb-4">{error}</Alert>}

          <Form onSubmit={handleLogin}>
            <Form.Group className="mb-3" id="username">
              <Form.Label>Username</Form.Label>
              <Form.Control
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                placeholder="Enter admin username"
                required
              />
            </Form.Group>
            <Form.Group className="mb-4" id="password">
              <Form.Label>Password</Form.Label>
              <Form.Control
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter password"
                required
              />
            </Form.Group>
            <Button disabled={loading} className="w-100 py-2 apple-btn apple-btn-primary" type="submit">
              {loading ? (
                <>
                  <Spinner animation="border" size="sm" className="me-2" /> Logging In...
                </>
              ) : (
                'Sign In to Dashboard'
              )}
            </Button>
          </Form>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default LoginPage;
